import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaWhatsapp, FaEnvelope, FaArrowRight } from 'react-icons/fa';
import './CallToAction.css';

const CallToAction = () => {
  const handleContactClick = (type) => {
    switch (type) {
      case 'phone':
        window.open('tel:+97444170859', '_self');
        break;
      case 'email':
        window.open('mailto:abrajaldhafna2014@gmail.com', '_self');
        break;
      case 'whatsapp':
        window.open('https://wa.me/97455994434', '_blank');
        break;
      default:
        break;
    }
  };

  return (
    <section className="cta-section py-20 bg-gradient-to-br from-primary-blue to-primary-blue-dark">
      <div className="container">
        <div className="cta-content text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="cta-title text-white mb-4">
              Ready to Get Started?
            </h2>
            <p className="cta-subtitle text-white mb-8">
              Contact us today for immediate manpower mobilization. 
              Our team is ready to serve your construction needs in Qatar.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="cta-buttons"
          >
            <motion.button
              className="btn btn-secondary btn-lg cta-btn"
              onClick={() => handleContactClick('phone')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPhone />
              Call Now
            </motion.button>

            <motion.button
              className="btn btn-outline btn-lg cta-btn"
              onClick={() => handleContactClick('whatsapp')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaWhatsapp />
              WhatsApp
            </motion.button>

            <motion.button
              className="btn btn-outline btn-lg cta-btn"
              onClick={() => handleContactClick('email')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaEnvelope />
              Email Quote
            </motion.button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            className="cta-info mt-12"
          >
            <div className="cta-info-grid">
              <div className="cta-info-item">
                <div className="cta-info-icon">⚡</div>
                <h4 className="text-white">Immediate Response</h4>
                <p className="text-white opacity-80">Get a response within 30 minutes</p>
              </div>
              
              <div className="cta-info-item">
                <div className="cta-info-icon">🚀</div>
                <h4 className="text-white">24/6 Availability</h4>
                <p className="text-white opacity-80">Round-the-clock support</p>
              </div>
              
              <div className="cta-info-item">
                <div className="cta-info-icon">✅</div>
                <h4 className="text-white">Certified Workers</h4>
                <p className="text-white opacity-80">All workers are certified and experienced</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            viewport={{ once: true }}
            className="cta-footer mt-12"
          >
            {/* <p className="text-white opacity-80 mb-4">
              <strong>Email:</strong> abrajqatar2014@gmail.com
            </p>
            <p className="text-white opacity-80">
              <strong>Phone:</strong> +974 1234 5678
            </p> */}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction; 